import { twMerge } from 'tailwind-merge';
import MuiButton from '@mui/material/Button';

import { ButtonProps } from './types';
import { colorClassname, variantClassname } from './styles';

export const Button = ({
  children,
  disabled,
  className,
  fullWidth,
  hasMinWidth,
  textClassName,
  color = 'primary',
  variant = 'contained',
  ...props
}: ButtonProps) => {
  const baseClasses = variantClassname[variant];
  const colorClasses = colorClassname[color]?.[variant];

  return (
    <MuiButton
      disableRipple
      disabled={disabled}
      className={twMerge(
        `h-10 rounded-xl px-4 py-2.5 normal-case`,
        baseClasses,
        colorClasses,
        hasMinWidth && 'min-w-0',
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      <span className={twMerge('text-sm leading-5 font-bold', textClassName)}>
        {children}
      </span>
    </MuiButton>
  );
};

export type { ButtonProps };
